
/**
 * 특정 사용자의 프로젝트를 조회할 때 사용하는 사용자 ID
 */
export type UserIdParam2Parameter = number;
